import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Message } from '../../classes/Message';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { IJobContact } from '../../interfaces/job-contact';
import { EventService, InboxJobsService, TelephonyService } from '../../services';
import { JobsContactService } from '../../services';
import { JobsService } from '../../services';
import { MapService } from '../../services';
import { SupplierScheduleService } from '../../services';
import { SupplierService } from '../../services';
import { InputHelper } from '../../utils/input.helper';

import { SelectItem, Dialog, MessageService } from 'primeng';
import { JobsDeploymentService } from '../../services';
import { MapControl } from '../map-control/map-control.component';
import { DriverPlanComponent } from './driver-plan.component';
import { uniqBy, includes, orderBy } from 'lodash';
import moment from 'moment';
import { SupplierCard, SupplierCardAction } from '../../interfaces/supplier-card-dto';
import { TelephonyEventEnum } from '../../interfaces/telephony/telephony-event';
import { TaskTypeHelper } from '../../utils/taskType.helper';
import { ILogCallJobInfo, ILogCallTaskInfo } from '../../interfaces/telephony/log-call-job-info';
import { IJobDeploymentInfo } from '../../interfaces/job-deployment';
import { IMarkerPoint } from '../map-control/marker.point';
import { ISupplierCard, SupplierAction } from 'src/app/interfaces/supplier-card';

export enum HistoryType {
  Allocated = 1,
  Messaged = 2,
  Phoned = 3,
  Rejected = 4,
  Directed = 5,
  Purchased = 6,
  BidPlaced = 7,
  Watched = 8,
}

@Component({
  selector: 'job-deployment',
  styleUrls: ['./job-deployment.component.scss'],
  templateUrl: './job-deployment.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class JobDeploymentComponent implements OnInit {
  public jobId: number;
  public isAccessDenied = false;
  public organisationTypeId = 1;
  public jobSummary: string;
  public sendingAlert = false;

  @ViewChild('directToSupplierMap') directToSupplierMap: MapControl;
  @ViewChild('driverPlan') driverPlanComponent: DriverPlanComponent;
  @ViewChild('directToSupplierDialog') directToSupplierDialog: Dialog;

  // Options
  public supplierOptions: SelectItem[] = [];
  public methodOptions: SelectItem[] = [];
  public outcomeOptions: SelectItem[] = [];

  // Dialogs
  public showLogContactDialog: boolean = false;
  public showAllocateJobDialog: boolean = false;
  public showDriverPlanDialog: boolean = false;
  public showDirectToSupplierDialog: boolean = false;
  // Entities
  public jobInfo: IJobDeploymentInfo;
  public jobInterest: SupplierCard[] = [];
  public watchingInterest: SupplierCard[] = [];
  public hiddenInterest: SupplierCard[] = [];
  public notInteractedInterest: SupplierCard[] = [];
  public jobInterestActions: SupplierCardAction[] = [
    {
      label: 'Follow-up',
      callback: (data) => {
        this.followUp(data);
      },
    },
    {
      label: 'Allocate',
      callback: (data) => {
        this.allocateJob(data);
      },
    },
  ];

  public jobHistory: any[] = [];
  public contact: IJobContact = { id: 0 };
  public supplier: SupplierCard;

  public suppliers: any[] = [];

  public supplierClassifications: SelectItem[] = [];
  public selectedClassifications: any[] = [];

  public supplierContractTypes: SelectItem[] = [];
  public selectedContractTypes: any[] = [];

  public directSuppliers: ISupplierCard[] = [];
  public directSuppliersActions: SupplierAction[] = [
    {
      label: 'Log Contact',
      callback: (data) => {
        this.logContactFromDTS(data);
      },
    },
    {
      label: 'Remove',
      callback: (data) => {
        this.removeDirectedSupplier(data);
      },
    },
    {
      label: 'Allocate',
      callback: (data) => {
        this.allocateJob(data);
      },
    },
  ];
  public searchRadius: number;
  public minRadius: number = 10;
  public maxRadius: number = 300;
  public locationPoins: IMarkerPoint[] = [];
  public searchingSuppliers: boolean = false;

  public iconMap: any = {};

  public jobFilterButtonVal: any = 'all';
  public smsText: string;
  public directToSupplierHeader: string;

  public excludeUnsuitable: boolean = true;

  public locationsData: { label: string; value: { lat: number; lng: number; index: number } }[];
  public customRadiusSelections: { lat: number; lng: number; index: number }[];

  public get grabDisabled(): boolean {
    return this.jobInfo?.grabDisabled || this.jobInfo?.isHeld;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public messageService: MessageService,
    public inputHelper: InputHelper,
    private jobDeploymentService: JobsDeploymentService,
    public inboxjobsService: InboxJobsService,
    public mapService: MapService,
    private contactService: JobsContactService,
    private supplierService: SupplierService,
    private jobService: JobsService,
    private supplierScheduleService: SupplierScheduleService,
    public telephonyService: TelephonyService,
    private eventService: EventService,
    private taskTypeHelper: TaskTypeHelper,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.jobId = Number(params['id']);
      this.loadJob();
      this.loadInterest();
      this.loadHistory();
    });

    this.loadOptions();

    // Init icons
    this.iconMap[HistoryType.Directed] = 'ui-icon-directions';
    this.iconMap[HistoryType.Messaged] = 'ui-icon-local-phone';
    this.iconMap[HistoryType.Phoned] = 'ui-icon-local-phone';
    this.iconMap[HistoryType.BidPlaced] = 'ui-icon-attach-money';
    this.iconMap[HistoryType.Allocated] = 'ui-icon-done';
    this.iconMap[HistoryType.Rejected] = 'ui-icon-close';
    this.iconMap[HistoryType.Watched] = 'ui-icon-location-searching';
    this.iconMap[HistoryType.Purchased] = 'ui-icon-shopping-cart';
  }

  loadJob() {
    this.jobDeploymentService
      .get(this.jobId)
      .then((res) => {
        this.jobInfo = {
          ...res,
          price: null,
          customerPremium: null,
          customerPremiums: [],
          supplierPremiums: [],
          supplierPremium: null,
        };

        // get locations for radius dropdown
        this.locationsData = [];
        this.jobInfo.tasks.forEach((t, index) => {
          let label = String.fromCharCode(65 + index * 2);
          this.populateLocationData(t.pickupLocation, label, index * 2);

          label = String.fromCharCode(65 + index * 2 + 1);
          this.populateLocationData(t.dropoffLocation, label, index * 2 + 1);
        });

        this.customRadiusSelections = this.locationsData.map((x) => {
          return x.value;
        });

        this.jobInfo.price = res.buyItNowPrice;
        this.smsText = res.smsText;

        this.jobInfo.supplierPremiums = this.jobInfo.pricePremiums.filter(
          (x) => x.isSupplierPremium,
        );
        this.jobInfo.supplierPremium = this.jobInfo.supplierPremiums.reduce(
          (a, b) => a + b.premium,
          0,
        );
        this.jobInfo.customerPremiums = this.jobInfo.pricePremiums.filter(
          (x) => !x.isSupplierPremium,
        );
        this.jobInfo.customerPremium = this.jobInfo.customerPremiums.reduce(
          (a, b) => a + b.premium,
          0,
        );

        this.loadSummary();
      })
      .catch((err) => {
        if (err.error && err.error.Message) {
          this.messageService.add(Message.Error(`${err.error.Message}`, 'Load Job'));
        } else {
          this.messageService.add(Message.Error(`Could not load job`, 'Load Job'));
        }
      });
  }

  private populateLocationData(loc, label, index) {
    this.locationsData.push({
      label: `${label} - ${loc.city}`,
      value: { lat: loc.latitude, lng: loc.longitude, index },
    });
  }

  public loadInterest() {
    this.jobDeploymentService.getJobInterest(this.jobId).then((res) => {
      res.forEach((x) => (x.actions = this.jobInterestActions));

      this.jobInterest = res;
      this.watchingInterest = this.jobInterest.filter((x) => x.status === 'Watching');
      this.hiddenInterest = this.jobInterest.filter((x) => x.status === 'Hidden');
      this.notInteractedInterest = this.jobInterest.filter((x) => x.status === 'Not Interacted');
    });
  }

  public loadHistory() {
    this.jobDeploymentService.getJobHistory(this.jobId).then((res) => {
      this.jobHistory = res;
      this.loadSummary();
    });
  }

  loadOptions() {
    this.contactService.getAllMethods().then((res) => {
      this.methodOptions = [];
      res.forEach((x) => this.methodOptions.push({ label: x.methodName, value: x.id }));
    });

    this.contactService.getAllOutcomes().then((res) => {
      this.outcomeOptions = [];
      res.forEach((x) => this.outcomeOptions.push({ label: x.outcomeName, value: x.id }));
    });

    var request = {
      jobId: this.jobId,
      isInitial: false,
      radius: 300,
      ignoreRadius: true,
    };

    this.jobDeploymentService.getSuppliersForJob(this.jobId).then((res) => {
      this.supplierOptions = res;

      this.supplierOptions = this.supplierOptions.sort((a, b) => {
        return a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' });
      });
    });
  }

  public jobDetails(newTab: boolean = false) {
    const url = 'app/jobscreen/' + this.jobId;

    if (!newTab) {
      this.router.navigate([url]);
    } else {
      window.open(url, '_blank');
    }
  }

  public jobDetailsNewTab() {
    window.open('/app/jobscreen/' + this.jobId, '_blank');
  }

  back() {
    this.router.navigate(['app/vmeinbox']);
  }

  // Log Contact

  logContact() {
    this.contact = { id: 0, jobId: this.jobId };
    this.showLogContactDialog = true;
  }

  logContactFromDTS(data) {
    this.contact = { id: 0, jobId: this.jobId, supplierName: data.name, supplierId: data.id };
    this.showLogContactDialog = true;
  }

  logContactSave(contact: IJobContact) {
    let promise: Promise<any>;
    if (contact.id == 0) {
      promise = this.contactService.create(contact);
    } else {
      promise = this.contactService.update(contact.id, contact);
    }

    promise.then((res) => {
      this.showLogContactDialog = false;
      this.loadInterest();
      this.loadHistory();
    });
  }

  public followUp(supplier) {
    this.contact = {
      id: 0,
      jobId: this.jobId,
      supplierId: supplier.id,
      isFollowUp: true,
      supplierName: supplier.name,
    };
    this.showLogContactDialog = true;
  }

  // Allocate Job
  public allocateJob(selectedSupplier: SupplierCard) {
    this.supplier = Object.assign({}, selectedSupplier);
    this.supplier.actions = [];

    this.showAllocateJobDialog = true;
  }

  public onAllocateJobSaved() {
    this.loadJob();
    this.loadInterest();
    this.loadHistory();
  }

  // Driver Plan
  public driverPlanClick(supplier) {
    this.supplier = supplier;
    this.driverPlanComponent.supplierId = supplier.id;
    this.driverPlanComponent.scheduledDate = this.jobInfo.scheduledDate;
    this.driverPlanComponent.load();

    this.showDriverPlanDialog = true;
  }

  // Direct To Supplier

  sendJobAlert: boolean = false;
  sendPushNotification: boolean = true;
  selectedAddSuppliers: number[];

  public directToSupplier() {
    this.directSuppliers = [];
    this.selectedAddSuppliers = [];

    let request = {
      jobId: this.jobId,
      isInitial: true,
      radius: this.searchRadius,
      locations: this.customRadiusSelections,
      onlyPushEnabled: this.sendPushNotification && !this.sendJobAlert,
    };

    this.searchingSuppliers = true;

    console.log('*** LOADING suppliers...');

    this.jobDeploymentService
      .searchSuppliers(request)
      .then((res) => {
        this.suppliers = res.suppliers;
        this.searchRadius = res.radius;
        this.refreshRadius();

        this.directToSupplierMap.autofitObjects();
        setTimeout((args) => {
          this.directToSupplierMap.autofitObjects();
        }, 1000);

        this.addSuppliersToList();
        this.updateHeader();
        this.filterDirectSupplierList();

        console.log('FINISHED DTS...');

        this.searchingSuppliers = false;
      })
      .catch((ex) => {
        this.searchingSuppliers = false;
      });

    this.showDirectToSupplierDialog = true;

    window.setTimeout(() => {
      this.directToSupplierDialog.maximize();
    }, 100);
  }

  updateHeader() {
    this.directToSupplierHeader =
      'Direct To Supplier  [' +
      this.jobInfo.jobNumber +
      ']: ' +
      moment(this.jobInfo.scheduledDate).format('ddd Do MMM YYYY') +
      ' - ' +
      this.directSuppliers.length +
      ' potential suppliers';
  }

  public async directToSupplierSave() {
    this.sendingAlert = true;

    await this.jobService
      .changeSupplierDetails({
        jobId: this.jobInfo.id,
        eRegionIds: [],
        supplierIds: this.directSuppliers.map((x) => x.id),
        smsText: this.smsText,
      })
      .then((x) => {
        this.loadHistory();
        this.loadInterest();
        this.messageService.add(
          Message.Success('Suppliers directed to job.', 'Change Supplier Price/Account'),
        );
      })
      .catch((x) => {
        this.messageService.add(
          Message.Error(
            'An error occurred while trying to modify the data. Try again. If the error persists, contact your administrator.',
            'Change Supplier Details',
          ),
        );
      });

    if (this.sendJobAlert) {
      await this.jobService
        .sendJobAlert(
          this.jobInfo.id,
          this.directSuppliers.map((x) => x.id),
        )
        .catch((e) => {
          this.messageService.add(
            Message.Error('An error occurred while trying to send SMS', 'Send SMS'),
          );
        })
        .then((x) => {
          this.messageService.add(Message.Success('Job alerts sent', 'Job alerts sent'));
        });
    }

    this.showDirectToSupplierDialog = false;
    this.sendingAlert = false;
  }

  public onAlterRadius(amount: number) {
    if (
      this.searchRadius + amount >= this.minRadius &&
      this.searchRadius + amount <= this.maxRadius
    ) {
      this.searchRadius += amount;
      this.onRadiusChange({ value: this.searchRadius });
    }
  }

  public onRadiusChange(event) {
    let request = {
      jobId: this.jobId,
      isInitial: false,
      radius: event.value,
      locations: this.customRadiusSelections,
      onlyPushEnabled: this.sendPushNotification && !this.sendJobAlert,
    };

    this.searchingSuppliers = true;
    this.jobDeploymentService
      .searchSuppliers(request)
      .then((res) => {
        this.suppliers = res.suppliers;
        this.refreshRadius();

        this.updateHeader();

        //this.directToSupplierMap.autofitObjects();
        setTimeout((args) => {
          this.directToSupplierMap.autofitObjects();
        }, 1000);

        // reset the directSuppliers list using all the suppliers in the map
        this.addSuppliersToList();

        this.filterDirectSupplierList();

        this.searchingSuppliers = false;
      })
      .catch((ex) => {
        this.searchingSuppliers = false;
      });
  }

  public refreshRadius() {
    this.locationPoins = [];

    if (this.customRadiusSelections?.length > 0) {
      this.customRadiusSelections.forEach((r) => {
        let color = r.index % 2 == 0 ? 'dodgerblue' : 'red';

        this.locationPoins.push({
          latitude: r.lat,
          longitude: r.lng,
          radius: this.searchRadius * 1609.34,
          color: color,
        });
      });

      return;
    }

    // if (this.customRadius) {
    //   this.locationPoins = [
    //     {
    //       latitude: this.customRadiusPos.lat,
    //       longitude: this.customRadiusPos.lng,
    //       label: 'Custom',
    //       radius: this.searchRadius * 1609.34,
    //       color: 'dodgerblue',
    //     },
    //   ];
    //
    //   return;
    // }

    //this.locationPoins = [];

    // add a location for the first and last location in the set of tasks
    let t = this.jobInfo.tasks[0];
    this.locationPoins = this.locationPoins.concat({
      longitude: t.pickupLocation.longitude,
      latitude: t.pickupLocation.latitude,
      radius: this.searchRadius * 1609.34,
      color: 'dodgerblue',
    });

    t = this.jobInfo.tasks[this.jobInfo.tasks.length - 1];
    this.locationPoins = this.locationPoins.concat({
      longitude: t.dropoffLocation.longitude,
      latitude: t.dropoffLocation.latitude,
      radius: this.searchRadius * 1609.34,
      color: 'red',
    });
  }

  public addSuppliersToList() {
    this.createDirectSupplierList();
    this.generateClassifications();
    this.generateContractTypes();
    this.sortDirectSupplierList();
  }

  public createDirectSupplierList() {
    this.directSuppliers = [];
    this.suppliers.forEach((x) => {
      x.actions = this.directSuppliersActions;

      x.isAvailable = this.supplierScheduleService.getDayAvailability(
        x.jobScheduledDate,
        0,
        0,
        x.supplierAvailabilityExceptions,
      );

      this.directSuppliers.push(x);
    });

    const nonExistentSupplierIds = this.selectedAddSuppliers.filter(
      (id) => !this.directSuppliers.some((supplier) => supplier.id === id),
    );

    nonExistentSupplierIds.forEach((id) => {
      this.jobDeploymentService.getSupplierCard(this.jobId, id).then((res) => {
        res.actions = this.directSuppliersActions;
        this.directSuppliers.push(res);
      });
    });
  }

  public generateClassifications() {
    // generate possible classification filters from current direct suppliers list
    let classes = uniqBy(this.directSuppliers, 'supplierOperationalData.classification');
    this.supplierClassifications = [];
    this.selectedClassifications = [];
    classes.forEach((x) => {
      this.supplierClassifications.push({
        label: x.supplierOperationalData.classification,
        value: x.supplierOperationalData.classification,
      });
    });

    this.supplierClassifications.map((item) => this.selectedClassifications.push(item.value));
  }

  public generateContractTypes() {
    // generate possible classification filters from current direct suppliers list

    let contractTypes = uniqBy(this.directSuppliers, 'organisationContractTypeId');
    this.supplierContractTypes = [];
    //this.selectedContractTypes = [];
    contractTypes.forEach((x) => {
      this.supplierContractTypes.push({
        label: x.organisationContractType.name,
        value: x.organisationContractTypeId,
      });
    });

    //Set default selected item to be 'Self-Employed' Contract Type (1)
    contractTypes
      .filter(
        (x) =>
          x.organisationContractTypeId == 1 &&
          !this.selectedContractTypes.includes(x.organisationContractTypeId),
      )
      .forEach((item) => {
        this.selectedContractTypes.push(item.organisationContractTypeId);
      });

    console.log(
      'Contract Types: ',
      this.supplierContractTypes,
      ' - selected: ',
      this.selectedContractTypes,
    );
  }
  public async onSupplierSelect() {
    console.log('Selection:', this.selectedAddSuppliers);

    if (!this.selectedAddSuppliers || this.selectedAddSuppliers.length === 0) {
      this.directSuppliers = [];
      return;
    }

    const selectedIds = this.selectedAddSuppliers;
    const existingIds = this.directSuppliers.map((supplier) => supplier.id);

    // Keep only selected suppliers that already exist
    this.directSuppliers = this.directSuppliers.filter((supplier) =>
      selectedIds.includes(supplier.id),
    );

    // Identify selected suppliers that do not yet exist
    const newSupplierIds = selectedIds.filter((id) => !existingIds.includes(id));

    try {
      const newSuppliers = await Promise.all(
        newSupplierIds.map(async (id) => {
          const card = await this.jobDeploymentService.getSupplierCard(this.jobId, id);
          card.actions = this.directSuppliersActions;
          return card;
        }),
      );

      this.directSuppliers.push(...newSuppliers);

      // Run post-processing once
      this.generateClassifications();
      this.generateContractTypes();
    } catch (error) {
      console.error('Failed to process all supplier cards:', error);
    }
  }

  public removeDirectedSupplier(item) {
    this.directSuppliers = this.directSuppliers.filter((obj) => obj !== item);
    this.selectedAddSuppliers = this.selectedAddSuppliers.filter((obj) => obj !== item.id);
  }

  private loadSummary() {
    let messages = [];

    let contactHistory = this.jobHistory.filter(
      (x) => x.historyType == HistoryType.Messaged || x.historyType == HistoryType.Phoned,
    );
    if (contactHistory.length != 0) {
      messages.push(
        `last contact was ${moment(contactHistory[0].time).format('ddd DD MMM YYYY HH:mm')} by ${
          contactHistory[0].supplierName
        }`,
      );
    }

    this.jobSummary = messages.join(',');
  }

  public filterDirectSupplierList() {
    // recreate the list so no info is lost when switching filters
    this.createDirectSupplierList();

    this.directSuppliers = this.directSuppliers.filter((x) =>
      includes(this.selectedClassifications, x.supplierOperationalData.classification),
    );
    this.directSuppliers = this.directSuppliers.filter((x) =>
      includes(this.selectedContractTypes, x.organisationContractTypeId),
    );

    // filter on required job status  (all, noJobs, onlyJobs)
    if (this.jobFilterButtonVal == 'noJobs') {
      this.directSuppliers = this.directSuppliers.filter((x) => x.taskCount == 0);
    } else if (this.jobFilterButtonVal == 'onlyJobs') {
      this.directSuppliers = this.directSuppliers.filter((x) => x.taskCount > 0);
    }

    if (this.excludeUnsuitable) {
      this.directSuppliers = this.directSuppliers.filter(
        (x) => !x.isExcluded && !x.isExclusive && x.tagRequirementsMet,
      );
    }

    this.selectedAddSuppliers = this.directSuppliers.map((x) => x.id);

    this.sortDirectSupplierList();
    this.updateHeader();
  }

  private sortDirectSupplierList() {
    this.directSuppliers = orderBy(
      this.directSuppliers,
      ['isAvailable', 'distanceToPickup', 'supplierOperationalData.totalJobs'],
      ['desc', 'asc', 'desc'],
    );
  }

  public onClassificationFilterChange(event) {
    // modify the filtered list of direct suppliers to match the currently selected items in the options array
    this.filterDirectSupplierList();
  }

  public onExcludeUnsuitableChanged() {
    this.filterDirectSupplierList();
  }

  public onJobFilterChange(event) {
    this.filterDirectSupplierList();
  }

  public onDirectToSupplierHide() {
    this.showDirectToSupplierDialog = false;
    this.smsText = this.jobInfo.smsText;
  }

  onContractTypeFilterChange($event: any) {
    this.filterDirectSupplierList();
  }

  onLocationsChange(event: any) {
    this.customRadiusSelections = event.value;
    this.onRadiusChange({ value: this.searchRadius });
  }

  logCall() {
    // console.log("JOB INFO: ", this.jobInfo);
    // return;

    let exTasks = this.jobInfo.tasks.map((tsk) => {
      return <ILogCallTaskInfo>{
        id: tsk.id,
        jobId: this.jobInfo.id,
        registrationNumber: tsk.vehicle.registrationNumber,
      };
    });

    let dto = <ILogCallJobInfo>{
      id: this.jobId,
      supplierId: this.jobInfo.supplierId,
      jobNumber: this.jobInfo.jobNumber,
      statusText: 'Awaiting deployment',
      tasks: exTasks,
      isAssociatedThisCall: true,
    };

    //this.eventService.AssociateJobWithCall.emit(dto);
    this.eventService.InternalTelephonyEvent.emit({
      eventType: TelephonyEventEnum.LogCall,
      telephonyJobInfo: dto,
      fromDeployment: true,
    });
  }
}
